import { createFeature, createReducer, on } from '@ngrx/store';
import { DEFAULT_PROFILE_IMAGE_URL } from '../../../core/constants/profile-image.constants';
import { SettingsActions } from './settings.actions';

export interface SettingsState {
  uploadingProfileImage: boolean;
  profileImageUrl: string;
  profileImageError: string | null;
}

const initialState: SettingsState = {
  uploadingProfileImage: false,
  profileImageUrl: DEFAULT_PROFILE_IMAGE_URL,
  profileImageError: null,
};

export const settingsFeature = createFeature({
  name: 'settings',
  reducer: createReducer(
    initialState,
    on(SettingsActions.setProfileImageUrl, (state, { url }) => ({
      ...state,
      profileImageUrl: url || DEFAULT_PROFILE_IMAGE_URL,
    })),
    on(SettingsActions.uploadProfileImage, (state, { previewUrl }) => ({
      ...state,
      uploadingProfileImage: true,
      profileImageUrl: previewUrl,
      profileImageError: null,
    })),
    on(SettingsActions.uploadProfileImageSuccess, (state, { url }) => ({
      ...state,
      uploadingProfileImage: false,
      profileImageUrl: url || state.profileImageUrl || DEFAULT_PROFILE_IMAGE_URL,
    })),
    on(SettingsActions.uploadProfileImageFailure, (state, { error }) => ({
      ...state,
      uploadingProfileImage: false,
      profileImageError: error,
    })),
  ),
});
